export default "__VITE_ASSET__18734709__"